import { useMemo } from "react";

import type { IDtefComparison } from "@/@types/store-conciliation";

import {
  DTEF_CATEGORIES_ORDER,
  DTEF_CATEGORY_LABELS_WARNING,
} from "../constants";

export function useDtefDivergentCategories(
  dtefComparison: IDtefComparison | null | undefined,
): string[] {
  return useMemo(() => {
    const comparisons = dtefComparison?.comparisons;
    if (!comparisons) return [];

    return DTEF_CATEGORIES_ORDER
      .filter(category => comparisons[category]?.divergent === true)
      .map(category => DTEF_CATEGORY_LABELS_WARNING[category]);
  }, [dtefComparison]);
}
